<span class="input-loader" [class.new-design]="newDesign"></span>
